import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import StyledTooltip from "../../common/StyledTooltip";

export default function VarianceSummaryTable({ varianceSummary }) {
  const data = (varianceSummary || []).map((item) => ({
    metric: item.metric,
    projected: item.projectedDisplay || "₹0",
    projectedOriginal: item.projected || 0,
    actual: item.actualDisplay || "₹0",
    actualOriginal: item.actual || 0,
    variance: item.varianceDisplay || "₹0",
    varianceOriginal: item.variance || 0,
    percent: `${item.pctVariance?.toFixed(1) || 0}%`,
    status: item.status,
  }));

  return (
    <div
      style={{
        background: "#fff",

        border: "1px solid #e5e7eb",

        borderRadius: "12px",

        padding: "20px",

               marginTop: "40px",

        boxShadow: "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)",
      }}
    >
      <h4
        style={{
          fontSize: "20px",
          fontWeight: "600",
          marginBottom: "15px",
        }}
      >
        Variance Summary
      </h4>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr
            style={{
              borderBottom: "1px solid #e5e7eb",
              color: "#374151",
              textAlign: "left",
            }}
          >
            <th style={thLeft}>Metric</th>

            <th style={thCenter}>Projected</th>

            <th style={thCenter}>Actual</th>

            <th style={thCenter}>Variance</th>

            <th style={thCenter}>% Variance</th>

            <th style={thCenter}>Status</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => (
            <tr
              key={index}
              style={{
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              <td style={tdLeft}>{item.metric}</td>

              <td style={tdCenter}>
                <StyledTooltip value={item.projectedOriginal}>
                  {item.projected}
                </StyledTooltip>
              </td>

              <td
                style={{
                  ...tdCenter,
                  color: "#155DFC",
                  fontWeight: "700",
                  fontSize: "16px",
                }}
              >
                <StyledTooltip value={item.actualOriginal}>
                  {item.actual}
                </StyledTooltip>
              </td>

              <td
                style={{
                  ...tdCenter,
                  color: item.status === "UP" ? "#00A63E" : "#E7000B",
                  fontWeight: "700",
                  fontSize: "16px",
                }}
              >
                <StyledTooltip value={item.varianceOriginal}>
                  {item.variance}
                </StyledTooltip>
              </td>

              <td
                style={{
                  ...tdCenter,
                  color: item.status === "UP" ? "#00A63E" : "#E7000B",
                  fontWeight: "700",
                  fontSize: "16px",
                }}
              >
                {item.percent}
              </td>

              <td style={tdCenter}>
                {item.status === "UP" ? (
                  <TrendingUp size={18} color="#00A63E" />
                ) : (
                  <TrendingDown size={18} color="#E7000B" />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const thLeft = {
  textAlign: "left",
  color: "#0A0A0A",
  padding: "10px 0",
  fontWeight: "700",
  fontSize: window.innerWidth >= 1800 ? '16px' : '14px',
};

const thCenter = {
  textAlign: "center",

  padding: "10px 0",
  fontSize: window.innerWidth >= 1800 ? '16px' : '14px',

};

const tdLeft = {
  padding: "14px 0",

  color: "#111827",
  fontSize: window.innerWidth >= 1800 ? '16px' : '14px',

};

const tdCenter = {
  textAlign: "center",

  padding: "14px 0",

  color: "#374151",
  fontSize: window.innerWidth >= 1800 ? '16px' : '14px',

};
